/**
 * How much of the remaining gap to close. Just past the line is a whisper;
 * only a deep overlap asks for the full clearance.
 */
export function gradeSeparation(d, need, band) {
  const gap = need - Math.max(d, 0);
  if (gap <= 0) return 0;
  const t = Math.min(1, gap / Math.max(band, 1e-4));
  return gap * t * t;
}

export function gradeVec(push, band) {
  const len = Math.hypot(push.x, push.y);
  if (len <= 1e-8) return push;
  const s = gradeSeparation(0, len, band) / len;
  return { x: push.x * s, y: push.y * s };
}

export function smoothGoal(prevX, prevY, nextX, nextY, k) {
  if (k >= 1) return { x: nextX, y: nextY };
  return {
    x: prevX + (nextX - prevX) * k,
    y: prevY + (nextY - prevY) * k,
  };
}

/**
 * Once tension drops, only ease home. A graze must not shove back out
 * or the node jitters on the return.
 */
export function releaseShove(curX, curY, rawX, rawY, clearing, releasing) {
  const curLen = Math.hypot(curX, curY);
  const rawLen = Math.hypot(rawX, rawY);
  const stillOut = curLen > 0.015;
  if (releasing && rawLen < Math.max(curLen + 0.12, 0.18)) {
    return { x: 0, y: 0, releasing: stillOut };
  }
  if (!clearing || rawLen < curLen * 0.88) {
    return { x: 0, y: 0, releasing: stillOut };
  }
  return { x: rawX, y: rawY, releasing: false };
}

/** A node squeezed between two occluders must not reverse shove each frame. */
export function shoveHoldsSide(prevX, prevY, nextX, nextY) {
  const prevLen = Math.hypot(prevX, prevY);
  const nextLen = Math.hypot(nextX, nextY);
  if (prevLen < 0.06 || nextLen < 0.06) return { x: nextX, y: nextY };
  const dot = (nextX * prevX + nextY * prevY) / (prevLen * nextLen);
  if (dot < 0) return { x: prevX, y: prevY };
  return { x: nextX, y: nextY };
}
